import IconBook from 'components/icons/book';
import IconCash from 'components/icons/cash';
import { IconChart } from 'components/icons/chart';
import IconCreditCardWithPlus from 'components/icons/creditCardWithPlus';
import IconMarketplace from 'components/icons/marketplace';
import { IconMobilePhoneWithSparkles } from 'components/icons/mobilePhoneWithSparkles';
import IconSettings from 'components/icons/settings';

import i18next from 'locales/i18next';

import RoutePath from 'router/path';
import LABELS from 'router/routes/keys';

import { AccountAccessLevel, AccountType } from 'types/account';
import { MenuItem } from 'types/routing';

import { PartnerFeatures, canManageAccount } from './features';

const { t } = i18next;

const getPwcMenuItems = (accountType: AccountType, accessLevel: AccountAccessLevel, features: PartnerFeatures): MenuItem[] => {
  const menuItems: MenuItem[] = [];
  const canManage = canManageAccount(accessLevel);
  const showAccountSettings = accountType === AccountType.Pwc && canManage;
  const showMerchantAccounts = accountType === AccountType.Pwc_Group || accountType === AccountType.PSP;

  if (features.pwc) {
    menuItems.push({
      subheader: t('Pay with crypto'),
    });

    menuItems.push({
      label: t('Orders'),
      icon: IconCash,
      to: RoutePath.Pwc.Orders.Root,
    });

    if (canManage) {
      menuItems.push({
        label: t(LABELS.PAYMENT_BY_LINK_MENU_ITEM),
        icon: IconCreditCardWithPlus,
        to: RoutePath.Pwc.PaymentByLink.Root,
      });
    }
  }

  if (features.cryptoPayout) {
    menuItems.push({
      subheader: t(LABELS.CRYPTO_PAYOUT_MENU_ITEM_SUBHEADER),
    });

    menuItems.push({
      label: t(LABELS.PAYOUTS_MENU_ITEM),
      icon: IconChart,
      to: RoutePath.CryptoPayout.Payouts.Root,
    });

    if (canManage) {
      menuItems.push({
        label: t(LABELS.PAYOUT_BY_LINK_MENU_ITEM),
        icon: IconMobilePhoneWithSparkles,
        to: RoutePath.CryptoPayout.PayoutByLink.Root,
      });
    }
  }

  if (showAccountSettings || showMerchantAccounts) {
    menuItems.push({
      subheader: t('General'),
    });

    if (showMerchantAccounts) {
      menuItems.push({
        label: t(LABELS.ACCOUNTS_MENU_ITEM),
        icon: IconMarketplace,
        to: RoutePath.Pwc.Accounts.Root,
      });
    }

    if (showAccountSettings) {
      menuItems.push({
        label: t('Account Settings'),
        icon: IconSettings,
        to: RoutePath.Pwc.AccountSettings.General,
      });
    }
  }

  menuItems.push({
    label: t('Documentation'),
    icon: IconBook,
    openInNewWindow: true,
    to: window?.s4cConfig?.documentationUrl || '',
  });

  return menuItems;
};

export const getMenuItems = (
  accountType: AccountType | undefined,
  accessLevel: AccountAccessLevel,
  features: PartnerFeatures,
): MenuItem[] => {
  switch (accountType) {
    case AccountType.Pwc:
    case AccountType.Pwc_Group:
    case AccountType.PSP:
      return getPwcMenuItems(accountType, accessLevel, features);
    case AccountType.Ramp:
    default:
      return [];
  }
};

export default getMenuItems;
